import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable, map} from 'rxjs';
import {NgEventBus} from 'ng-event-bus';
import {AppConfigService} from "./app-config.service";

@Injectable({
    providedIn: 'root'
})
export class TraitsService {
    title = 'Trait Service';
    traits = [];
    planPurposeCode = undefined;
    surveyMethod = undefined;

    constructor(
        private http: HttpClient,
        private eventBus: NgEventBus,
        private appConfigService: AppConfigService
    ) {}

    hasTraits() {
        return !(typeof this.traits === undefined || this.traits.length === 0);
    }

    setPlanTraitsRequestData(data: {planPurposeCode?: string; surveyMethod?: string}): Observable<any> {
        if (data.hasOwnProperty('planPurposeCode')) {
            this.planPurposeCode = data.planPurposeCode;
        }

        if (data.hasOwnProperty('surveyMethod')) {
            this.surveyMethod = data.surveyMethod;
        }

        return this.calculateTraits();
    }

    calculateTraits(): Observable<[]> {
        const url = this.appConfigService.settings.apiGatewayUrl + '/traits/getPlanTraits';
        const request = {
            planPurposeCode: this.planPurposeCode,
            surveyMethod: this.surveyMethod
        };
        const result = this.http.post<[]>(url, request).pipe(
            map(newTraits => {
                if (newTraits) {
                    let addedTraits = newTraits.filter(newTrait => {
                        return !this.traits.some(existingTrait => {
                            return newTrait === existingTrait;
                        });
                    });

                    Array.prototype.push.apply(this.traits, addedTraits);

                    let removedTraits = this.traits.filter(existingTrait => {
                        return !newTraits.some(newTrait => {
                            return newTrait === existingTrait;
                        });
                    });

                    removedTraits.forEach(trait => {
                        this.traits.splice(this.traits.indexOf(trait), 1);
                    });

                    this.traits.sort();
                    const metaData = {traits: this.traits, addedTraits: addedTraits, removedTraits: removedTraits};
                    this.eventBus.cast('nlr:trait-service:traitsChanged', metaData);
                    console.log("traits updated")
                }
                return newTraits;
            })
        );

        return result;
    }

    //TO-DO: The test needs to be conducted when the caller part is complete
    criteriaMatches(planTraitCriteria, blankMatchesAll) {
        return planTraitCriteria && planTraitCriteria.length ? planTraitCriteria.some(trait => this.traits.includes(trait)) : blankMatchesAll;
    }
}
